import { useEffect, useRef, useState } from 'react';

const useScrollable = (dependencies = []) => {
  const ref = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);
  const [isAtBottom, setIsAtBottom] = useState(true);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const updateScrollable = () => {
      const scrollable = element.scrollHeight > element.clientHeight;
      setIsScrollable(scrollable);

      if (scrollable) {
        updateScrollPosition();
      } else {
        setIsAtTop(true);
        setIsAtBottom(true);
      }
    };

    const updateScrollPosition = () => {
      const { scrollTop, scrollHeight, clientHeight } = element;
      setIsAtTop(scrollTop === 0);
      setIsAtBottom(scrollTop + clientHeight >= scrollHeight);
    };

    updateScrollable();

    const resizeObserver = new ResizeObserver(updateScrollable);
    resizeObserver.observe(element);

    window.addEventListener('resize', updateScrollable);
    element.addEventListener('scroll', updateScrollPosition);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', updateScrollable);
      element.removeEventListener('scroll', updateScrollPosition);
    };
  }, dependencies);

  return {
    ref,
    isScrollable,
    isAtTop,
    isAtBottom,
  };
};

export default useScrollable;
